// extracted by mini-css-extract-plugin
export default {"wrapper":"i4-z"};